const availableColors = [
    'bg-icoBlue-100 text-icoBlue',
    'bg-icoYellow-100 text-icoYellow',
    'bg-icoGreen-100 text-icoGreen',
    'bg-icoPurple-100 text-icoPurple',
    'bg-icoRed-100 text-icoRed',
    'bg-icoPink-100 text-icoPink',
    'bg-icoAquaBlue-100 text-icoAquaBlue',
    'bg-icoOrange-100 text-icoOrange'
] as const;

/**
 * get random color based on const availableColors
 **/
export function getRandomColor() {
    const randomIndex = Math.floor(Math.random() * availableColors.length);
    return availableColors[randomIndex];
}
